import React from 'react';
import classNames from 'classnames';

import { observer } from 'mobx-react';

import { useStyles } from 'ui/base/theme';
import { ActiveButton, DefaultButton } from 'ui/public/button';
import { StandardPage } from 'ui/base/page/standard_page';

import { PlanType } from 'services/accounts/types';
import { getPlanTypeSubtitle, getPlanTypeTitle } from 'services/accounts/logic/plans/plans';

import { themedModuleIconImageStyles } from 'assets/enums/modules/modules';
import { themedDeviceTypeIconImageStyles } from 'assets/enums/device_types/device_types';
import { getPlanTypeIcon, themedPlanTypeIconImageStyles } from 'assets/enums/plan_types/plan_types';

import { PlanItemFirewallBaseOptionalModalProps } from '../plan_item_firewall';

import ManagePlansMessages from '../../../../manage_plans_messages';
import Messages from './plan_firewall_header_modal_messages';

type PlanItemFirewallHeaderModalProps = PlanItemFirewallBaseOptionalModalProps;
export const PlanItemFirewallHeaderModal = observer(({ styles, store, modal, root }: PlanItemFirewallHeaderModalProps) => {
  const moduleIconImages = useStyles(themedModuleIconImageStyles);
  const deviceTypeIconImages = useStyles(themedDeviceTypeIconImageStyles);

  const planTypeIconImages = useStyles(themedPlanTypeIconImageStyles);
  const planTypeIconImage = getPlanTypeIcon(planTypeIconImages, PlanType.FIREWALL);

  // Handle navigation
  const onNext = React.useCallback(() => {
    // Set subsequent steps to default
    store.package_store.setSelected(store.package_default);
    store.billing_store.setSelected(store.billing_default);
    store.payment_store.setSelected(store.payment_default);

    // Go to package modal
    modal.history.push(`${root}/package`);
  }, [store, modal, root]);

  return (
    <div className={classNames(styles.modalContainerLarge, styles.modalContainerPopOut)}>
      <StandardPage>
        <div className={styles.modalHeaderRow}>
          {Messages.name()}
          <button
            className={styles.modalCloseIcon}
            onClick={modal.dismissModal}
            type='button'
          />
        </div>
        <div className={styles.modalContentRow}>
          <div className={styles.section}>
            <div className={styles.heroBig}>
              <img className={styles.heroIcon} src={planTypeIconImage} alt='Plan Icon' />
              <div className={styles.heroTitle}>
                {getPlanTypeTitle(PlanType.FIREWALL)}
              </div>
              <div className={styles.heroDetail}>
                {getPlanTypeSubtitle(PlanType.FIREWALL)}
              </div>
              <p className={styles.heroText}>
                {Messages.following()}
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <div className={classNames(styles.field, styles.item)}>
              <div className={styles.fieldTextLeft} >
                {Messages.featureFirewall()}
              </div>
              <img className={styles.fieldIcon} src={moduleIconImages.devices} alt='Devices Icon' />
            </div>
            <div className={classNames(styles.field, styles.item)}>
              <div className={styles.fieldTextLeft} >
                {Messages.featureUpdates()}
              </div>
              <img className={styles.fieldIcon} src={moduleIconImages.alerts} alt='Alerts Icon' />
            </div>
            <div className={classNames(styles.field, styles.item)}>
              <div className={styles.fieldTextLeft} >
                {Messages.featureApp()}
              </div>
              <img className={styles.fieldIcon} src={deviceTypeIconImages.mobile} alt='Mobile Icon' />
            </div>
          </div>
          <div className={styles.spacer} />
          <ActiveButton onClick={onNext}>
            {ManagePlansMessages.actionSubscribe()}
          </ActiveButton>
          <DefaultButton type='button' onClick={modal.history.goBack}>
            {ManagePlansMessages.actionBack()}
          </DefaultButton>
        </div>
      </StandardPage>
    </div>
  );
});
